<template>
  <partner-layout>
    <v-container>
      <feed :feedUrl="'https://blog.zwiz.ai/feed'" :limit="5"></feed>
    </v-container>
  </partner-layout>
</template>

<script>
import Feed from './Feed'
export default {
  components: {
    Feed
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/partner/Blog.vue